// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pLn8","buttons":"styles_buttons__I07Rk"};